import { render, staticRenderFns } from "./layoutWithoutDrawer.vue?vue&type=template&id=04bf6b00&lang=pug"
import script from "./layoutWithoutDrawer.vue?vue&type=script&lang=js"
export * from "./layoutWithoutDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports